import { useHotkeys } from 'react-hotkeys-hook';

import { HOTKEY_SCOPES, HotkeyScope } from './scopes';

export interface EscapeHotkeyOptions {
  /** Disable the binding without unmounting the caller. Default `true`. */
  enabled?: boolean;
  /** Scope the binding lives in. Default `overlay` (never globally suppressed). */
  scope?: HotkeyScope;
}

/**
 * Escape-to-dismiss for genuinely-custom overlays only.
 *
 * Do NOT use this on Radix-backed components (Dialog/Modal/Popover handle
 * Escape natively) — reserve it for hand-rolled drawers/panels.
 *
 * Unlike `useActionHotkey`, Escape opts INTO form tags: a search box inside a
 * drawer must still close the drawer on Escape.
 */
export function useEscapeHotkey(
  onEscape: () => void,
  opts: EscapeHotkeyOptions = {}
): void {
  const { enabled = true, scope = HOTKEY_SCOPES.overlay } = opts;

  useHotkeys(
    'escape',
    () => onEscape(),
    {
      enabled,
      enableOnFormTags: ['input', 'textarea', 'select'],
      scopes: [scope],
    },
    [onEscape]
  );
}
